// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,ts_nocheck=true"
// @generated from file pull_requests/v1/thread_preview_positioning.proto (package github.pull_requests.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file pull_requests/v1/thread_preview_positioning.proto.
 */
export const file_pull_requests_v1_thread_preview_positioning: GenFile = /*@__PURE__*/
  fileDesc("CjFwdWxsX3JlcXVlc3RzL3YxL3RocmVhZF9wcmV2aWV3X3Bvc2l0aW9uaW5nLnByb3RvEhdnaXRodWIucHVsbF9yZXF1ZXN0cy52MSLWAQogVGhyZWFkUHJldmlld1Bvc2l0aW9uaW5nUmVzcG9uc2USVwoHdGhyZWFkcxgBIAMoCzJGLmdpdGh1Yi5wdWxsX3JlcXVlc3RzLnYxLlRocmVhZFByZXZpZXdQb3NpdGlvbmluZ1Jlc3BvbnNlLlRocmVhZHNFbnRyeRpZCgxUaHJlYWRzRW50cnkSCwoDa2V5GAEgASgDEjgKBXZhbHVlGAIgASgLMikuZ2l0aHViLnB1bGxfcmVxdWVzdHMudjEuUG9zaXRpb25lZFRocmVhZDoCOAEixgMKEFBvc2l0aW9uZWRUaHJlYWQSMAoKY29tbWl0X29pZBgBIAEoCzIcLmdvb2dsZS5wcm90b2J1Zi5TdHJpbmdWYWx1ZRI1CgpkaWZmX2xpbmVzGAIgAygLMiEuZ2l0aHViLnB1bGxfcmVxdWVzdHMudjEuRGlmZkxpbmUSMwoNZW5kX2RpZmZfc2lkZRgDIAEoCzIcLmdvb2dsZS5wcm90b2J1Zi5TdHJpbmdWYWx1ZRItCghlbmRfbGluZRgEIAEoCzIbLmdvb2dsZS5wcm90b2J1Zi5JbnQzMlZhbHVlEioKBHBhdGgYBSABKAsyHC5nb29nbGUucHJvdG9idWYuU3RyaW5nVmFsdWUSNQoPc3RhcnRfZGlmZl9zaWRlGAYgASgLMhwuZ29vZ2xlLnByb3RvYnVmLlN0cmluZ1ZhbHVlEi8KCnN0YXJ0X2xpbmUYByABKAsyGy5nb29nbGUucHJvdG9idWYuSW50MzJWYWx1ZRITCgtpc19vdXRkYXRlZBgIIAEoCBI8ChZvcmlnaW5hbF9kaWZmX3BhdGhfdXJpGAkgASgLMhwuZ29vZ2xlLnByb3RvYnVmLlN0cmluZ1ZhbHVlIscBCghEaWZmTGluZRIqCgRodG1sGAEgASgLMhwuZ29vZ2xlLnByb3RvYnVmLlN0cmluZ1ZhbHVlEikKBGxlZnQYAiABKAsyGy5nb29nbGUucHJvdG9idWYuSW50MzJWYWx1ZRIqCgVyaWdodBgDIAEoCzIbLmdvb2dsZS5wcm90b2J1Zi5JbnQzMlZhbHVlEioKBHRleHQYBCABKAsyHC5nb29nbGUucHJvdG9idWYuU3RyaW5nVmFsdWUSDAoEdHlwZRgFIAEoCWIGcHJvdG8z", [file_google_protobuf_wrappers]);

/**
 * Response payload for
 * GET /:owner/:repo/pull/:number/page_data/thread_preview_positioning
 *
 * Defined by PullRequests::PageData::SharedController#thread_preview_positioning.
 *
 * The legacy endpoint renders a top-level JSON object keyed by review-thread id
 * (e.g. `{ "123": { ... } }`). Proto3-JSON always serializes a message to an
 * object, so the keyed entries are wrapped in a `threads` map field; the client
 * reads `response.threads`.
 *
 * @generated from message github.pull_requests.v1.ThreadPreviewPositioningResponse
 */
export type ThreadPreviewPositioningResponse = Message<"github.pull_requests.v1.ThreadPreviewPositioningResponse"> & {
  /**
   * Keyed by PullRequestReviewThread id. int64 keys because thread ids can
   * exceed the int32 range; proto3-JSON serializes map keys as strings, which
   * matches the legacy object keys.
   *
   * @generated from field: map<int64, github.pull_requests.v1.PositionedThread> threads = 1;
   */
  threads: { [key: string]: PositionedThread };
};

/**
 * Describes the message github.pull_requests.v1.ThreadPreviewPositioningResponse.
 * Use `create(ThreadPreviewPositioningResponseSchema)` to create a new message.
 */
export const ThreadPreviewPositioningResponseSchema: GenMessage<ThreadPreviewPositioningResponse> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_thread_preview_positioning, 0);

/**
 * Positioning + diff context for a single review thread preview.
 *
 * @generated from message github.pull_requests.v1.PositionedThread
 */
export type PositionedThread = Message<"github.pull_requests.v1.PositionedThread"> & {
  /**
   * Wrapper types are used throughout because the serializer can emit explicit
   * JSON null for these fields and a proto3 default (empty string / 0) would
   * be indistinguishable from a real value the client must treat as null.
   *
   * @generated from field: google.protobuf.StringValue commit_oid = 1;
   */
  commitOid?: string;

  /**
   * @generated from field: repeated github.pull_requests.v1.DiffLine diff_lines = 2;
   */
  diffLines: DiffLine[];

  /**
   * @generated from field: google.protobuf.StringValue end_diff_side = 3;
   */
  endDiffSide?: string;

  /**
   * @generated from field: google.protobuf.Int32Value end_line = 4;
   */
  endLine?: number;

  /**
   * @generated from field: google.protobuf.StringValue path = 5;
   */
  path?: string;

  /**
   * @generated from field: google.protobuf.StringValue start_diff_side = 6;
   */
  startDiffSide?: string;

  /**
   * @generated from field: google.protobuf.Int32Value start_line = 7;
   */
  startLine?: number;

  /**
   * @generated from field: bool is_outdated = 8;
   */
  isOutdated: boolean;

  /**
   * @generated from field: google.protobuf.StringValue original_diff_path_uri = 9;
   */
  originalDiffPathUri?: string;
};

/**
 * Describes the message github.pull_requests.v1.PositionedThread.
 * Use `create(PositionedThreadSchema)` to create a new message.
 */
export const PositionedThreadSchema: GenMessage<PositionedThread> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_thread_preview_positioning, 1);

/**
 * A single rendered diff line within a thread preview.
 *
 * @generated from message github.pull_requests.v1.DiffLine
 */
export type DiffLine = Message<"github.pull_requests.v1.DiffLine"> & {
  /**
   * @generated from field: google.protobuf.StringValue html = 1;
   */
  html?: string;

  /**
   * @generated from field: google.protobuf.Int32Value left = 2;
   */
  left?: number;

  /**
   * @generated from field: google.protobuf.Int32Value right = 3;
   */
  right?: number;

  /**
   * @generated from field: google.protobuf.StringValue text = 4;
   */
  text?: string;

  /**
   * UPPER_SNAKE_CASE line kind (e.g. CONTEXT, ADDITION, DELETION); the
   * serializer upcases the loader value.
   *
   * @generated from field: string type = 5;
   */
  type: string;
};

/**
 * Describes the message github.pull_requests.v1.DiffLine.
 * Use `create(DiffLineSchema)` to create a new message.
 */
export const DiffLineSchema: GenMessage<DiffLine> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_thread_preview_positioning, 2);

import { registerSchemaHash } from "../../../schema-hash-registry";
registerSchemaHash(ThreadPreviewPositioningResponseSchema, "33429a2f4ade")
registerSchemaHash(PositionedThreadSchema, "2c759d7ee32d")
registerSchemaHash(DiffLineSchema, "d3549d739a31")
